import React, { useEffect } from 'react';
import { useResourceCenterArticle } from 'app/templates/ResourceCenterArticle/useResourceCenterArticle';
import ArticleWithTableOfContents from 'molecules/ArticleWithTableOfContents/ArticleWithTableOfContents';
import { useArticleTableOfContents } from 'src/hooks/useArticleTableOfContents';
import TableOfContentsStatic from 'molecules/TableOfContents/TableOfContentsStatic';

const ArticleBody = (): JSX.Element => {
  const { title, slug, contentHtmlAst, tableOfContents, attachments } = useResourceCenterArticle();

  // Table Of Contents Provider is set globally and used by the Html Parser AST
  // TODO: MKT-9829: If the HTML Parser AST is replaced, reconsider this approach VS passing TOC as args to it.
  const { setTableOfContentsConfig } = useArticleTableOfContents();

  useEffect(() => {
    if (!tableOfContents?.length) return;

    const MobileTableOfContents = () => (
      <TableOfContentsStatic
        title={'In this article'}
        slug={slug}
        articleTitle={title}
        pathPrefix={'resources'}
        tableOfContents={tableOfContents}
      />
    );

    setTableOfContentsConfig({
      tocData: tableOfContents,
      hideOnDesktop: true,
      customizableComponent: MobileTableOfContents,
    });
  }, [tableOfContents, setTableOfContentsConfig]);

  return (
    <ArticleWithTableOfContents
      slug={slug}
      articleTitle={title}
      pathPrefix={'resources'}
      contentHtmlAst={contentHtmlAst}
      tableOfContents={tableOfContents}
      attachments={attachments}
    />
  );
};

export default ArticleBody;
